var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGhost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(111,66)translate(189,234)rotate(0)translate(-189,-234) scale(4.934725848563969,4.934725848563969)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("defs", {
    className: "defs"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-11.699999999999998,-2.5)",
    d: "M69.3,45.4c0,-2.76142 2.23858,-5 5,-5c2.76142,0 5,2.23858 5,5c0,2.76142 -2.23858,5 -5,5c-2.76142,0 -5,-2.23858 -5,-5zM50,2.5c-20.3,0 -36.9,15.8 -38.2,35.7h-0.1v1.6v53.5c0,0 2.2,6.3 8.8,-1.6c6.7,-7.9 11.5,1.6 11.5,1.6c0,0 5.2,9.5 11.5,0c6.3,-9.5 12.5,0 12.5,0c0,0 5.8,8.1 11.1,0c5.3,-8.1 10.6,-1.6 10.6,-1.6c0,0 10.2,11 10.2,0c0,-8.2 0.4,-49 0.4,-50.9c0,-21.1 -17.1,-38.3 -38.3,-38.3zM47.2,57c-5.5,0 -10,-5.2 -10,-11.7c0,-6.4 4.5,-11.7 10,-11.7c5.5,0 10,5.2 10,11.7c0,6.5 -4.4,11.7 -10,11.7zM71.1,57c-5.5,0 -10,-5.2 -10,-11.7c0,-6.4 4.5,-11.7 10,-11.7c5.5,0 10,5.2 10,11.7c0,6.5 -4.5,11.7 -10,11.7zM45.4,45.4c0,-2.76142 2.23858,-5 5,-5c2.76142,0 5,2.23858 5,5c0,2.76142 -2.23858,5 -5,5c-2.76142,0 -5,-2.23858 -5,-5z",
    fill: "#000000",
    className: "fill c1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/Ghost.72f3547b734e23d8d762927983cd58a2.svg";
export { ForwardRef as ReactComponent };